import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../common/PageHeader";
import { __ } from "../../translations";
import { useAppSelector } from "../../store/store";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { languageSelector, themeSelector } from "../../service/common.slice";

export const Terms = () => {
    const navigate = useNavigate();
    const theme = useAppSelector(themeSelector);
    const language = useAppSelector(languageSelector);
    const content = theme?.termsAndConditions[language]||theme?.termsAndConditions["de"];

    const back = () => {
        navigate(-1);
    };

    return (
        <>
            <PageHeader onBack={back} isBackAvailable={true} header={__("Terms")} />
            <div className="help-content">
                <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
            </div>
        </>
    );
};
